module.exports = __webpack_public_path__ + "nissan.4d1c7a08e6f6fb901349.png";